const MakerWorkerIndex = () => import(/* webpackChunkName: "makerWorker" */ '../components/makerWorker/Index')
const MakerWorkerImportPerson = () => import(/* webpackChunkName: "makerWorker" */ '../components/makerWorker/detail/ImportPerson')
const MakerWorkerSettleDetail = () => import(/* webpackChunkName: "makerWorker" */ '../components/makerWorker/detail/SettleDetails')
const MakerWorkerConfirmDetail = () => import(/* webpackChunkName: "makerWorker" */ '../components/makerWorker/detail/confirmDetail/index')
const MakerWorkerFail = () => import(/* webpackChunkName: "makerWorker" */ '../components/makerWorker/detail/confirmDetail/fail')

export default [
	{
		path:'',
		component:MakerWorkerIndex,
	},
	{
		path:'import-person/:type/:id',
		component:MakerWorkerImportPerson,
	},
	{
		path:'settle-detail/:id',
		component:MakerWorkerSettleDetail,
	},
	{
		path:'confirm-detail/:id',
		component:MakerWorkerConfirmDetail,
	},
	{
		path:'confirm-fail/:id',
		component:MakerWorkerFail,
	},
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/makerWorker.js